import(/* webpackMode: "eager", webpackExports: ["AccountProfileWebPage"] */ "/opt/buildhome/repo/src/app/[lng]/(main)/_account-web/personal-web.tsx");
